import React from 'react';
import { createPortal } from 'react-dom';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { SearchCtx, readContextFromPage } from './SearchContext';
import { SearchBar, Sidebar, PropertyListing } from '../features/search/ui';
import { useSearch } from '../features/search/hooks/useSearch';

function SearchPage() {
  const { data, loading, error, searchParams, setSearchParams } = useSearch();
  const contentEl = document.getElementById('property-search-content');

  return (
    <>
      <SearchBar searchParams={searchParams} setSearchParams={setSearchParams} />
      {contentEl && createPortal(
        <div className="flex flex-col lg:flex-row gap-4 items-start">
          {data?.hasResults && (
            <aside className="w-full lg:w-72 xl:w-80 flex-shrink-0">
              <Sidebar data={data} searchParams={searchParams} setSearchParams={setSearchParams} />
            </aside>
          )}
          <div className="flex-1 min-w-0 w-full">
            <PropertyListing
              data={data}
              loading={loading}
              error={error}
              searchParams={searchParams}
              setSearchParams={setSearchParams}
            />
          </div>
        </div>,
        contentEl
      )}
    </>
  );
}

interface SearchAppProps {
  el: HTMLElement;
}

export function SearchApp({ el }: SearchAppProps) {
  const ctx = readContextFromPage(el);
  return (
    <SearchCtx.Provider value={ctx}>
      <BrowserRouter>
        <Routes>
          <Route path="*" element={<SearchPage />} />
        </Routes>
      </BrowserRouter>
    </SearchCtx.Provider>
  );
}
